import React from 'react';

//Component for not found page

export default function NotFound() { 
    return <h1>404, nothing is here</h1>;
}